import { useState, useEffect, useCallback } from 'react';
import { fetchDetalleDiferencias } from '../services/reportesV2.services';

// Hook: Detalle de diferencias (ciclos sin lote + abortados sin clasificar)
export const useDetalleDiferencias = ({ idLavanderia, dateRange, enabled = true }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !dateRange) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchDetalleDiferencias({ idLavanderia, dateRange });
      setData(result);
    } catch (e) {
      setError(e.message || 'Error al cargar detalle de diferencias');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, dateRange, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
